<div class="input-number">
  <label class="col-form-label" v-if="label" :for="id" ref="labelForm">{{ label }} <span class="required" v-if="required">(*)</span></label>
  <input class="form-control" @click="$emit('eventClick')" :class="{ 'is-error': isError }" v-model="value" type="text" :id="id" :readonly="readonly" :disabled="disabled" @blur="onBlur" :placeholder="placeholder"/>
  <div class="error-text" v-if="errorText" :style="{left: distanceWithLabel}">{{errorText}}</div>
</div>
